import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function AdminSettings() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { (async () => setS((await api.get("/admin/settings")).data))(); }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.patch("/admin/settings", s);
      toast.success("Paramètres enregistrés");
    } catch { toast.error("Erreur"); } finally { setBusy(false); }
  };

  if (!s) return <div className="text-muted-foreground">Chargement…</div>;

  return (
    <div className="space-y-6 max-w-3xl" data-testid="admin-settings-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-navy-900/60 font-semibold">Paramètres</div>
        <h1 className="font-heading font-extrabold text-4xl text-navy-900 tracking-tighter mt-1">Compteur & contenus</h1>
      </div>

      <section className="card-premium p-6 md:p-8 space-y-5">
        <h2 className="font-heading font-bold text-xl text-navy-900">Tarifs de référence</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Prix Adult (€)"><Input type="number" value={s.base_price_adult} onChange={(e) => setS({ ...s, base_price_adult: parseFloat(e.target.value) || 0 })} data-testid="setting-price-adult" /></Field>
          <Field label="Prix Junior/Senior (€)"><Input type="number" value={s.base_price_junior} onChange={(e) => setS({ ...s, base_price_junior: parseFloat(e.target.value) || 0 })} /></Field>
        </div>
      </section>

      <section className="card-premium p-6 md:p-8 space-y-5">
        <h2 className="font-heading font-bold text-xl text-navy-900">Comportement du compteur</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Mode par défaut">
            <Select value={s.default_mode} onValueChange={(v) => setS({ ...s, default_mode: v })}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="simple">Simple</SelectItem>
                <SelectItem value="simulation">Simulation</SelectItem>
                <SelectItem value="pedagogical">Pédagogique</SelectItem>
              </SelectContent>
            </Select>
          </Field>
          <Field label="Stratégie d'affichage">
            <Select value={s.display_strategy} onValueChange={(v) => setS({ ...s, display_strategy: v })}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="prudent">Prudent</SelectItem>
                <SelectItem value="ambitious">Ambitieux</SelectItem>
              </SelectContent>
            </Select>
          </Field>
          <Field label="Plafond global mensuel (€)"><Input type="number" value={s.global_monthly_cap} onChange={(e) => setS({ ...s, global_monthly_cap: parseFloat(e.target.value) || 0 })} /></Field>
        </div>
        <Field label="Disclaimer affiché"><Textarea rows={2} value={s.disclaimer || ""} onChange={(e) => setS({ ...s, disclaimer: e.target.value })} /></Field>
      </section>

      <section className="card-premium p-6 md:p-8 space-y-5">
        <h2 className="font-heading font-bold text-xl text-navy-900">Contenu éditorial</h2>
        <Field label="Titre du hero"><Input value={s.hero_title || ""} onChange={(e) => setS({ ...s, hero_title: e.target.value })} /></Field>
        <Field label="Sous-titre du hero"><Textarea rows={2} value={s.hero_subtitle || ""} onChange={(e) => setS({ ...s, hero_subtitle: e.target.value })} /></Field>
      </section>

      <div>
        <button onClick={save} disabled={busy} className="btn-navy" data-testid="save-settings-btn">
          <Save className="w-4 h-4" /> {busy ? "Enregistrement…" : "Enregistrer"}
        </button>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-wider font-semibold mb-1.5 block text-navy-900/70">{label}</Label>
      {children}
    </div>
  );
}
